import { makeAutoObservable } from 'mobx'
import CustomMeasure from '@/components/Cesium/CustomMeasure'
import MeasurePoint from '@/components/Cesium/CustomMeasure/MeasurePoint'

export class Measure {
  constructor() {
    makeAutoObservable(this)
  }

  measureUtils: any = undefined
  isClosedMeasure: boolean = false
  meaPoint: any = undefined

  planeDistance({ cesiumview, callback }: any) {
    let customMeasurecurr

    if (this.measureUtils === undefined) {
      customMeasurecurr = new CustomMeasure(cesiumview, callback)
      this.measureUtils = customMeasurecurr
    }
    else {
      customMeasurecurr = this.measureUtils
    }
    customMeasurecurr.planeDistance()
  }

  drawTrianglesMeasureGraphics({ cesiumview, callback }: any) {
    let customMeasurecurr
    if (this.measureUtils === undefined) {
      customMeasurecurr = new CustomMeasure(cesiumview, callback)
      this.measureUtils = customMeasurecurr
    }
    else {
      customMeasurecurr = this.measureUtils
    }
    customMeasurecurr.drawTrianglesMeasureGraphics()
  }

  areaMeasure({ cesiumview, callback }: any) {
    let customMeasurecurr
    if (this.measureUtils === undefined) {
      customMeasurecurr = new CustomMeasure(cesiumview, callback)
      this.measureUtils = customMeasurecurr
    }
    else {
      customMeasurecurr = this.measureUtils
    }
    customMeasurecurr.areaMeasure()
  }

  elevationMeasure(cesiumview: any) {
    const meaPoint = new MeasurePoint(cesiumview)
    meaPoint.create()
    this.meaPoint = meaPoint
  }

  clearElevationMeasure() {
    if (this.meaPoint) {
      this.meaPoint.clear()
      this.meaPoint = undefined
    }
  }

  public setIsClosedMeasure(bool: boolean) {
    this.isClosedMeasure = bool
  }

  destroy() {
    if (this.measureUtils !== undefined) {
      this.measureUtils.destroy()
      this.measureUtils = undefined
    }
  }
}
